
















































import axios from 'axios';
import CoAlert from '../co-alert/CoAlert.vue';
import {
    getDirectVideoEmbedUrl,
    getTrustedVideoEmbedUrl,
    getVideoOEmbedUrl,
    getVideoProvider,
    VideoProvider,
} from '../../../utils/video.ts';

// Use an isolated client because provider requests must not inherit application headers.
const oEmbedClient = axios.create();

export default {
    name: 'CoVideoEmbed',
    components: {
        CoAlert,
    },
    props: {
        url: {
            type: String,
            required: true,
        },
        preferDirectEmbed: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            embedUrl: null,
            embedTitle: '',
            hasError: false,
            requestSequence: 0,
        };
    },
    computed: {
        videoProvider() {
            return getVideoProvider(this.url);
        },
    },
    watch: {
        url: {
            handler() {
                this.loadEmbed();
            },
            immediate: true,
        },
        preferDirectEmbed() {
            this.loadEmbed();
        },
    },
    methods: {
        async loadEmbed() {
            this.requestSequence += 1;
            const { requestSequence } = this;
            const provider = getVideoProvider(this.url) as VideoProvider | null;
            const directEmbedUrl = this.preferDirectEmbed ? getDirectVideoEmbedUrl(this.url) : null;
            const oEmbedUrl = getVideoOEmbedUrl(this.url);

            this.embedUrl = null;
            this.embedTitle = '';
            this.hasError = false;

            if (!provider) {
                this.hasError = true;
                return;
            }

            // Post previews can use TikTok's official player directly instead of depending on a fragile oEmbed request.
            if (directEmbedUrl) {
                this.embedUrl = directEmbedUrl;
                this.embedTitle = this.$t(`labels.${provider}VideoPlayer`);
                return;
            }

            if (!oEmbedUrl) {
                this.hasError = true;
                return;
            }

            try {
                const response = await oEmbedClient.get(oEmbedUrl);
                if (requestSequence !== this.requestSequence) {
                    return;
                }

                const embedUrl = getTrustedVideoEmbedUrl(response.data?.html, provider, this.url);
                this.embedUrl = embedUrl;
                this.hasError = !embedUrl;
                this.embedTitle = response.data?.title || this.$t(`labels.${provider}VideoPlayer`);
            } catch (error) {
                if (requestSequence !== this.requestSequence) {
                    return;
                }

                // Explain provider failures instead of leaving an empty content card.
                this.embedUrl = null;
                this.hasError = true;
            }
        },
    },
};
